// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"331":"4c4f1a46","538":"6b28481a","674":"fb64cf3f","983":"8e5c6e87"}[chunkId] + ".js";
};